import { Layout, LegacyCard, Tabs } from "@shopify/polaris";
import React, { useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import EventsTab from "./segmentedTabs/EventsTab";
import FullfilmentChecker from "./segmentedTabs/FullfilmentChecker";
import PaypalChecker from "./segmentedTabs/PaypalChecker";
import PaypalSettings from "./segmentedTabs/PaypalSettings";
import Processes from "./segmentedTabs/Processes";
import PullLogs from "./segmentedTabs/PullLogs";

const workspacePanels = [
  {
    id: "support-processes",
    content: "Processes",
    accessibilityLabel: "Processes and historical support",
    Panel: Processes,
  },
  {
    id: "support-fulfillment-checker",
    content: "Fulfillment checker",
    accessibilityLabel: "Fulfillment checker",
    Panel: FullfilmentChecker,
  },
  {
    id: "support-paypal-checker",
    content: "PayPal checker",
    accessibilityLabel: "PayPal checker",
    Panel: PaypalChecker,
  },
  {
    id: "support-paypal-settings",
    content: "PayPal settings",
    accessibilityLabel: "PayPal account settings",
    Panel: PaypalSettings,
  },
  {
    id: "support-events",
    content: "Events",
    accessibilityLabel: "Store events",
    Panel: EventsTab,
  },
  {
    id: "support-pull-logs",
    content: "Pull logs",
    accessibilityLabel: "Pull logs",
    Panel: PullLogs,
  },
];

const tabs = workspacePanels.map(({ id, content, accessibilityLabel }) => ({
  id,
  content,
  accessibilityLabel,
  panelID: `${id}-panel`,
}));

const InvestigationWorkspace = () => {
  const { id: shopId } = useParams();
  const [selected, setSelected] = useState(0);
  const handleTabChange = useCallback((selectedTabIndex) => {
    setSelected(selectedTabIndex);
  }, []);
  const selectedWorkspace = workspacePanels[selected] || workspacePanels[0];
  const SelectedPanel = selectedWorkspace.Panel;
  const selectedTab = tabs[selected] || tabs[0];

  return (
    <>
      <Layout.Section>
        <div className="wrapper">
          <LegacyCard sectioned>
            <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
              <p className="card_title">Investigation workspace</p>
              <p className="secondaryText">
                Open one support data source at a time. Read-only histories load only
                when selected.
              </p>
            </div>
            <div style={{ marginTop: "16px" }}>
              <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange} />
            </div>
          </LegacyCard>
        </div>
      </Layout.Section>
      <section
        id={selectedTab.panelID}
        role="tabpanel"
        aria-labelledby={selectedTab.id}
        aria-label={selectedTab.accessibilityLabel}
        style={{ width: "100%" }}
      >
        <SelectedPanel key={`${String(shopId ?? "unknown")}:${selectedTab.id}`} />
      </section>
    </>
  );
};

export default InvestigationWorkspace;
